import { Checkbox as AntdCheckbox } from 'antd';
import type { ComponentProps } from 'react';

import styles from './checkbox.module.scss';

export type CheckboxProps = ComponentProps<typeof AntdCheckbox>;

export function Checkbox({ className, ...rest }: CheckboxProps) {
  return (
    <AntdCheckbox {...rest} className={[styles.checkbox, className].filter(Boolean).join(' ')} />
  );
}
